import { themeVariable } from '../../themes/helpers/themeVariable';

export const maxWidth = themeVariable('global', 'maxWidth', {
  default: '1880px',
});
